import { render, staticRenderFns } from "./courseLeadersListItem.vue?vue&type=template&id=259a896c&scoped=true&lang=pug"
import script from "./courseLeadersListItem.vue?vue&type=script&lang=js"
export * from "./courseLeadersListItem.vue?vue&type=script&lang=js"
import style0 from "./courseLeadersListItem.vue?vue&type=style&index=0&id=259a896c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259a896c",
  null
  
)

export default component.exports